import { render, staticRenderFns } from "./SapSyncParamMapping.vue?vue&type=template&id=522f8194"
import script from "./SapSyncParamMapping.vue?vue&type=script&lang=js"
export * from "./SapSyncParamMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports